export default "__VITE_ASSET__fbtEGVEj__"